import { create } from 'zustand';

const useSearchStore = create((set) => ({
  query: '',
  submittedQuery: '',
  setQuery: (query) => set({ query }),
  setSubmittedQuery: (submittedQuery) => set({ submittedQuery }),
  clearQuery: () => set({ query: '', submittedQuery: '' }),
}));

export default useSearchStore;
